// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3yYy2","option":"styles_option__C33dg","active":"styles_active__VISQg"};